var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define("SuiteCommerce.ItemRecSys.Common.Helper", ["require", "exports", "Utils", "SC.Configuration"], function (require, exports, Utils, Configuration) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WIDGET_VERSION = void 0;
    exports.getSuiteletUrl = getSuiteletUrl;
    exports.isCmsAdmin = isCmsAdmin;
    exports.WIDGET_VERSION = '3.2.13';
    function getSuiteletUrl(script_id, deployment_id, params) {
        params = params || {};
        var parsedURL = new URL(SC.ENVIRONMENT.baseUrl);
        var url = "".concat(parsedURL.origin, "/app/site/hosting/scriptlet.nl");
        return Utils.addParamsToUrl(url, __assign({ script: script_id, deploy: deployment_id, widgetVersion: exports.WIDGET_VERSION, site: SC.ENVIRONMENT.siteSettings.siteid }, params));
    }
    function isCmsAdmin() {
        try {
            var adminPath = '/cms/' + Configuration.get('cms.adapterVersion') + '/admin/cms.jsp';
            return window.self !== window.top && window.top.location.host == window.self.location.host && window.top.location.pathname == adminPath;
        }
        catch (_a) {
            return false;
        }
    }
});
